import { CircularProgress } from '@mui/material';
import { useTranslation } from 'next-i18next';
import VyDataGrid, { VyColDef } from '../../common/VyDataGrid';

interface MatchesTableProps {
  matches: any[];
  onLimitChange: (newLimit: number) => void;
  onPageChange: (page: number) => void;
  isLoading: boolean;
  totalRowCount: number;
  pageSize: number;
  page: number;
}

export const MatchesTable = (props: MatchesTableProps) => {
  const { matches, totalRowCount, pageSize, isLoading, onLimitChange, onPageChange, page } = props;

  const { t } = useTranslation();
  if (isLoading) return <CircularProgress />;
  if (!matches || matches.length === 0) return null;

  const columns: VyColDef[] = [
    {
      field: 'userA',
      headerName: t('account:matching.userA'),
      width: 250,
      sortable: false,
      editable: false,
      valueGetter: (value, row) => row.participantA.registration?.user?.name,
    },
    {
      field: 'userB',
      headerName: t('account:matching.userB'),
      width: 250,
      sortable: false,
      editable: false,
      valueGetter: (value, row) => row.participantB.registration?.user?.name,
    },
    {
      field: 'lastMatch',
      headerName: 'Last Match',
      width: 250,
      sortable: false,
      editable: false,
      renderCell: (r) => <>{r.row.datetime_last_match ? new Date(r.row.datetime_last_match).toLocaleString() : <></>}</>,
    },
  ];

  return (
    <VyDataGrid
      paginationMode="server"
      pageSizeOptions={[25, 50, 100]}
      pagination
      rows={matches}
      columns={columns}
      disableRowSelectionOnClick
      paginationModel={{
        page: page,
        pageSize: pageSize,
      }}
      onPaginationModelChange={({ page, pageSize }) => {
        onPageChange(page);
        onLimitChange(pageSize);
      }}
      loading={isLoading}
      rowCount={totalRowCount}
    />
  );
};
